<template>
  <div class="wrapper">
    <public-title column="栏目名" @gotobtn="btn" @gotoinquire="eventinquire" :isbtn="true" btnname="新增"
      icon="el-icon-plus">
    </public-title>
    <div class="content">
      <el-table :data="tabledata" style="width: 100%" @sort-change="sortChange">
        <el-table-column prop="phone" type="index" label="序号" width="120" align="center">
        </el-table-column>
        <el-table-column prop="columnName" label="栏目名" align="center" sortable="custom">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180" align="center" sortable="custom">
        </el-table-column>
        <el-table-column prop="articeNum" label="文章数" align="center" sortable="custom">
        </el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="edit(scope.$index, scope.row)">修改</el-button>
            <!-- <el-popconfirm icon="el-icon-info" v-model="DelVisible" confirmButtonText='确定' cancelButtonText='取消'
              @onConfirm="handleDelete(scope.$index, scope.row)" iconColor="red" style="margin-left: 10px;"
              :title="scope.row.articeNum>0?'该栏目已有关联文章，是否确认删除？':'您确定要删除这一条记录吗？'"> -->
              <el-button slot="reference" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            <!-- </el-popconfirm> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[15, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper"
        :total="totals">
      </el-pagination>
    </div>
    <el-dialog :title="issubbtn?'新增栏目':'修改栏目'" :visible.sync="dialogVisible" width="35%">
      <el-form ref="form" :model="subform" :rules="rules" label-width="80px">
        <el-form-item label="栏目名称" prop="name">
          <el-input v-model="subform.name"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" @click="onSubmit('form')">保存</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import publicTitle from '../../../components/publicTitle'
  export default {
    components: { publicTitle },
    props: {},
    data() {
      return {
        tabledata: [],
        currentPage: 1,
        pageSize: 15,
        pageIndex: 1,
        totals: 0,
        form: {},
        subform:{
          name:''
        },
        DelVisible: false,
        dialogVisible: false,
        rules: {
          name: [
            { required: true, message: '请输入栏目名称', trigger: 'blur' },
          ],
        },
        issubbtn:false, // edit fals - add true
        id:'',
        sortName:"",//排序名称
        sortType:"",//排序升序降序
      };
    },
    computed: {
    },
    mounted() {
      this.updata()
    },
    methods: {
      updata(pageIndex = 1, pageSize = 15, Vcolumn = '') {

        if(this.sortType == null){
          this.sortType = "";
          this.sortName = "";
        }
        let sortType = this.sortType;
        let sortName =this.sortName;
        this.$http({
          url: this.$api.columnlists + `?pageIndex=${pageIndex}&pageSize=${pageSize}&name=${Vcolumn}&sortName=${sortName}&sortType=${sortType}`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            this.tabledata = res.data.data.records
            this.pageSize = res.data.data.size
            this.currentPage = res.data.data.current
            this.totals = res.data.data.total
          }else{
            this.$toast("error", res.data.msg);
          }
        });
      },
      eventinquire(form) {
        this.form = form
        this.updata(1, this.pageSize, this.form.Vcolumn)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.updata(this.pageIndex, this.pageSize ,this.form.Vcolumn)
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.updata(this.pageIndex, this.pageSize ,this.form.Vcolumn)
      },
      edit(index, item) {
        console.log(item,'22222')
        this.subform.name = item.columnName
        this.dialogVisible = true;
        this.issubbtn = false
        this.id = item.id
      },
      btn(){
        this.subform.name = ''
        this.dialogVisible = true
        this.subform.name = ''
        this.issubbtn = true
      },
      //删除 update:qyl 2020/3/7 增加删除提示
      handleDelete(index, item) {
        this.$confirm(item.articeNum>0?'该栏目已有关联文章，是否确认删除？':"您确定要删除这一条记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: this.$api.columndel + `${item.id}`,
          method: "DELETE",
        }).then(res => {
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            this.updata(1, this.pageSize, this.form.Vcolumn)
          }else{
            this.$toast("error", res.data.msg);
          }
          this.DelVisible = false
        });
      })
        /* if(){

        } */
        
      },
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let userId = JSON.parse(sessionStorage.getItem("userinfo")).id
            if(this.issubbtn){
              let data = {
                userId,
                columnName:this.subform.name,
              }
              this.$http({
                url: this.$api.columnsave,
                method: "POST",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(1, this.pageSize,this.form.Vcolumn)
                  this.dialogVisible = false
                  this.$refs['form'].resetFields();
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            } else {
              let data = {
                userId,
                columnName:this.subform.name,
                id:this.id
              }
              this.$http({
                url: this.$api.columnupdate,
                method: "PUT",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(this.pageIndex, this.pageSize,this.form.Vcolumn)
                  this.dialogVisible = false
                  this.$refs['form'].resetFields();
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            }
          } else {
            return false;
          }
        });
      },
      //筛选排序
      sortChange (column, event) {
         console.log("column")
        this.sortName = column.prop;
        this.sortType = column.order;
        // if(column.order =='ascending'){
        //   this.sortType = 'asc'
        //   }else if(column.order =='descending'){
        //     this.sortType = 'desc'
        //     }else{
        //       this.sortType = ''
        //       };
        this.updata(this.pageIndex, this.pageSize,this.form.Vcolumn)
      
    },
    },
    created() { },
    beforeDestroy() { }
  };
</script>

<style lang="scss" scoped>
  .role-select {
    width: 290px !important;
  }

  .content {
    background: #fff;
    width: 100%;
    height: 77vh;
  }

  /deep/.el-pagination {
    text-align: center;
    padding: 10px 0;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .wrapper{
    // height: 100%;

  }
  /deep/.el-table{

      // overflow-x: scroll;
}
/deep/.el-table::before{
  background-color: none;
  opacity:0;
}
/deep/.el-table th>.cell{
  color: #000;
}
/deep/.el-table__body-wrapper{
    height:70vh;
    overflow-y: auto;
}
</style>